export default {
  apiPath: 'https://imodus-api-staging.herokuapp.com/api',
  hangfirePath: 'https://imodus-api-staging.herokuapp.com',
};
